import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import usePortal from 'hooks/usePortal';
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';

import './Modal.scss';

const Modal = ({children, extraClassName, onClose}, ref) => {
  const portal = usePortal({
    id: 'modal-root',
    onMount(_, modal) {
      if (modal) {
        modal.setAttribute('class', 'modal-positioner');
      }

      const appRoot = document.body;
      if (appRoot) appRoot.setAttribute('modal-open', 'true');
    },
    onUnmount() {
      const appRoot = document.body;
      if (appRoot) appRoot.removeAttribute('modal-open');
    },
  });

  useEffect(() => {
    if (portal) {
      disableBodyScroll(portal.querySelector('.modal__inner'));
    }
    return clearAllBodyScrollLocks;
  }, [portal]);

  if (!portal) return null;

  return ReactDOM.createPortal(
    <div className="modal" role="dialog" aria-modal="true" data-shmid="modal">
      <div className="modal__backdrop" onClick={onClose} />
      <div className={`modal__inner ${extraClassName}`} ref={ref}>
        {children}
      </div>
    </div>,
    portal,
  );
};

export default React.forwardRef(Modal);
